module.exports = __webpack_public_path__ + "static/media/kaligreen.2da60333.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/climasense/cenicilla_pimiento/preventiva/kaligreen.png
// module id = 2204
// module chunks = 3